export default {
    region: process.env.REACT_APP_AWS_REGION,
    IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID, //'us-east-1:f31b5f7b-9936-4874-9167-7462a3727c7c',
    UserPoolId: process.env.REACT_APP_USER_POOL_ID, //'us-east-1_BXWpAFkl5',
    ClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID, //'7h0hrnnghu8c28t60bs4k7rg7k',
};
